module.exports = __webpack_public_path__ + "static/media/Img.d2b0a48d.jpeg";